import "../GlobalStyle.css";
import "../PCStyle.css";
import "../TabletStyle.css";
import "../MobileStyle.css";
import styled from "styled-components";
import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { media } from "../Utils/media";
import { useNavigate } from "react-router-dom"; // 추가
import { ReactComponent as Menu } from "./menuIcon.svg";
import { ReactComponent as Close } from "./closeIcon.svg";
import { fluidFont } from "../Utils/fontSize";

const GNB = () => {
  const [currentPage, setCurrentPage] = useState("home");
  const [isScrolled, setIsScrolled] = useState(false);
  const [isServiceHovered, setIsServiceHovered] = useState(false);
  const [isMenuClicked, setIsMenuClicked] = useState(false);
  const [isGNBHovered, setIsGNBHovered] = useState(false);
  const isMobile = window.matchMedia("(max-width: 768px)").matches;
  const location = useLocation();
  const navigate = useNavigate(); // 추가
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  React.useEffect(() => {
    // 현재 경로를 기반으로 현재 페이지 추적
    const path = location.pathname;
    if (path === "/about") {
      setCurrentPage("about");
    } else if (path === "/services1" || path === "/services2" || path === "/services3") {
      setCurrentPage("services1");
    } else if (path === "/portfolio") {
      setCurrentPage("portfolio");
    } else if (path === "/news") {
      setCurrentPage("news");
    } else if (path === "/partner") {
      setCurrentPage("partner");
    } else if (path === "/team") {
      setCurrentPage("team");
    } else if (path === "/contact") {
      setCurrentPage("contact");
    } else {
      setCurrentPage("home");
    }
  }, [location]);

  const onEnterHoverGNB = () => {
    setIsGNBHovered(true);
  };

  const onLeaveHoverGNB = () => {
    setIsGNBHovered(false);
  };

  const onClickAboutMenu = () => {
    setIsMenuClicked(false);
    navigate("/about");
  };

  const onClickService1Menu = () => {
    setIsMenuClicked(false);
    navigate("/services1");
  };

  const onClickService2Menu = () => {
    setIsMenuClicked(false);
    navigate("/services2");
  };

  const onClickService3Menu = () => {
    setIsMenuClicked(false);
    navigate("/services3");
  };

  const onClickPortfolioMenu = () => {
    setIsMenuClicked(false);
    navigate("/portfolio");
  };

  const onClickContactMenu = () => {
    setIsMenuClicked(false);
    navigate("/contact");
  };

  return (
    <>
      <GnbBG
        $isScrolled={isScrolled}
        $isGNBHovered={isGNBHovered}
        $isExpanded={isServiceHovered}
        $isMenuClicked={isMenuClicked}
        onMouseLeave={onLeaveHoverGNB}
        onMouseEnter={onEnterHoverGNB}
      >
        <GnbContentWrapper>
          <Link to="/" style={{ display: "flex", zIndex: "1", textDecoration: "none" }}>
            <LogoContainer>
              <img src={require("../Assets/Logo/newlogo.png")} alt="Logo" width="100%" height="auto" />
            </LogoContainer>
          </Link>
          {!isMobile && (
            <LabelArea>
              <LabelUl>
                <LabelContainer>
                  <Link to="/about" style={{ display: "flex", zIndex: "1", textDecoration: "none" }}>
                    <LabelCopy $currentPage={currentPage} $pageId="about">
                      About
                    </LabelCopy>
                  </Link>
                </LabelContainer>
                <ServiceLabelContainer onMouseEnter={() => setIsServiceHovered(true)} onMouseLeave={() => setIsServiceHovered(false)}>
                  <Link to="/services1" style={{ display: "flex", zIndex: "1", textDecoration: "none" }}>
                    <LabelCopy $currentPage={currentPage} $pageId="services1">
                      Services
                    </LabelCopy>
                  </Link>
                  {isServiceHovered && (
                    <LabelDepth2Ul>
                      <LabelDepth2Li onClick={() => navigate("/services1")}>서비스1</LabelDepth2Li>
                      <LabelDepth2Li onClick={() => navigate("/services2")}>서비스2</LabelDepth2Li>
                      <LabelDepth2Li onClick={() => navigate("/services3")}>서비스3</LabelDepth2Li>
                    </LabelDepth2Ul>
                  )}
                </ServiceLabelContainer>
                <LabelContainer>
                  <Link to="/portfolio" style={{ display: "flex", zIndex: "1", textDecoration: "none" }}>
                    <LabelCopy $currentPage={currentPage} $pageId="portfolio">
                      Portfolio
                    </LabelCopy>
                  </Link>
                </LabelContainer>
                <LabelContainer style={{ marginRight: "0px" }}>
                  <Link to="/contact" style={{ display: "flex", zIndex: "1", textDecoration: "none" }}>
                    <LabelCopy $currentPage={currentPage} $pageId="contact">
                      Contact
                    </LabelCopy>
                  </Link>
                </LabelContainer>
              </LabelUl>
            </LabelArea>
          )}
          {isMobile && !isMenuClicked ? (
            <MenuButton onClick={() => setIsMenuClicked(true)}>
              <Menu style={{ width: 20, height: 20, fill: "white" }} />
            </MenuButton>
          ) : isMobile && isMenuClicked ? (
            <MenuButton onClick={() => setIsMenuClicked(false)}>
              <Close style={{ width: 20, height: 20, fill: "white" }} />
            </MenuButton>
          ) : null}
        </GnbContentWrapper>
        {isMobile && isMenuClicked && (
          <MenuArea>
            <MenuLabelCopy $currentPage={currentPage} $pageId="about" onClick={onClickAboutMenu}>
              About
            </MenuLabelCopy>
            <MenuLabelCopy $currentPage={currentPage} $pageId="services1" style={{ marginTop: "32px" }}>
              Services
            </MenuLabelCopy>
            <MenuSubLabelCopy onClick={onClickService1Menu} style={{ marginTop: "16px" }}>
              서비스1
            </MenuSubLabelCopy>
            <MenuSubLabelCopy onClick={onClickService2Menu} style={{ marginTop: "16px" }}>
              서비스2
            </MenuSubLabelCopy>
            <MenuSubLabelCopy onClick={onClickService3Menu} style={{ marginTop: "16px" }}>
              서비스3
            </MenuSubLabelCopy>
            <MenuLabelCopy $currentPage={currentPage} $pageId="portfolio" onClick={onClickPortfolioMenu} style={{ marginTop: "32px" }}>
              Portfolio
            </MenuLabelCopy>
            <MenuLabelCopy $currentPage={currentPage} $pageId="contact" onClick={onClickContactMenu} style={{ marginTop: "32px" }}>
              Contact
            </MenuLabelCopy>
          </MenuArea>
        )}
      </GnbBG>
      <GnbLine $isExpanded={isServiceHovered} onMouseEnter={() => setIsServiceHovered(true)} onMouseLeave={() => setIsServiceHovered(false)} />
    </>
  );
};

const GnbBG = styled.div`
  display: flex;
  position: fixed;
  z-index: 3;
  background-color: rgb(255, 255, 255);
  width: 100%;
  ${media.web`
    top: 0px;
    height: ${({ $isExpanded }) => ($isExpanded ? "238px" : "90px")};
  `}

  ${media.mobile`
    top: 0px;
    height: ${({ $isMenuClicked }) => ($isMenuClicked ? "100vh" : "64px")};
    flex-direction: ${({ $isMenuClicked }) => ($isMenuClicked ? "column" : "row")};
  `}

  ${({ $isScrolled, $isGNBHovered, $isMenuClicked }) =>
    $isScrolled || $isGNBHovered || $isMenuClicked
      ? `
        background: rgba(255, 255, 255, 0.1);
        backdrop-filter: blur(20px);
        -webkit-backdrop-filter: blur(20px);
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
      `
      : `
        background: transparent;
        backdrop-filter: none;
        -webkit-backdrop-filter: none;
        box-shadow: none;
      `}
`;

const GnbLine = styled.div`
  display: flex;
  position: fixed;
  z-index: 5;
  background-color: rgba(255, 255, 255, 0.3);
  width: 100%;
  ${media.web`
    top: 90px;
    height: ${({ $isExpanded }) => ($isExpanded ? "1px" : "0px")};
  `}
  ${media.mobile`
    top: 64px;
    height: ${({ $isExpanded }) => ($isExpanded ? "1px" : "0px")};
  `} /* ${({ $isScrolled, $isGNBHovered }) =>
    $isScrolled || $isGNBHovered
      ? `
        background: rgba(255, 255, 255, 0.1);
        backdrop-filter: blur(20px);
        -webkit-backdrop-filter: blur(20px);
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
      `
      : `
        background: transparent;
        backdrop-filter: none;
        -webkit-backdrop-filter: none;
        box-shadow: none;
      `} */
`;

const GnbContentWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center; // 이게 중요! 높이에 관계없이 수직 중앙
  /* background-color: red; */
  ${media.web`
    padding: 0 4vw;
    height: 90px;
  `}

  ${media.mobile`
    /* padding: 0 0 0 4vw; */
    height: 64px;
  `}
`;

const LogoContainer = styled.div`
  display: flex;
  z-index: 1;
  margin-left: 4vw;
  ${media.web`
    width: 167.625px;
    height: 20.625px;
  `}

  ${media.mobile`
    width: 167.625px;
    height: 20.625px;
  `}
`;

const LabelArea = styled.div`
  display: flex;
  margin-left: auto;
  height: 90px;
`;

const LabelUl = styled.ul`
  display: flex;
  align-items: center;
  gap: 0 clamp(16px, 8vw, 80px);
  list-style: none;
`;

const LabelDepth2Ul = styled.ul`
  flex-direction: column;
  align-items: flex-start;
  width: 440px;
  position: absolute;
  top: 100%;
  left: 0;
  padding: 24px 0;
  z-index: 4;
  list-style: none;
  /* gap: 32px 0px; */
`;

const LabelDepth2Li = styled.li`
  position: relative;
  gap: 0 5px;
  height: auto;
  padding: 6px 0;
  color: rgb(207, 207, 207);
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 500;
  font-size: ${fluidFont(14, 18)};
  &:hover {
    color: white;
  }
`;

const LabelContainer = styled.li`
  position: relative;
  display: flex;
  flex-direction: row;
  z-index: 1;
  cursor: pointer;
  align-items: center;
  ${media.web`
    height:90px;
    text-decoration: none;
  `}
`;

const ServiceLabelContainer = styled.li`
  position: relative;
  display: flex;
  flex-direction: row;
  z-index: 1;
  cursor: pointer;
  align-items: center;
  ${media.web`
    height:90px;
    text-decoration: none;
  `}
`;

const LabelCopy = styled.div`
  color: ${({ $currentPage, $pageId }) => ($currentPage === $pageId ? "#94BAFD" : "rgb(255, 255, 255)")};
  font-family: "Pretendard";
  font-style: normal;
  ${media.web`
    font-weight: 500;
    font-size: ${fluidFont(14, 18)};
    letter-spacing: -3%;
  `}
`;

const MenuButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background-color: transparent;
  margin: 0 0 0 auto;
  padding: 0px;
  height: 64px;
  width: 64px;
  cursor: pointer;
`;

const MenuArea = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  padding: 40px 4vw;
`;

const MenuLabelCopy = styled.button`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  cursor: pointer;
  margin: 0px;
  padding: 0px;
  border: none;
  background-color: transparent;
  width: 100%;
  text-align: left;
  ${media.mobile`
    font-weight: 700;
    font-size: 44px;
    letter-spacing: -3%;

  `}
`;

const MenuSubLabelCopy = styled.button`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  cursor: pointer;
  margin: 0px;
  padding: 0px;
  border: none;
  background-color: transparent;
  width: 100%;
  text-align: left;
  ${media.mobile`
    font-weight: 500;
    font-size: 24px;
    letter-spacing: -3%;
  `}
`;

export default GNB;
